<template>
  <div class="common-content">
    <div class="top-banner">
      <div class="img-bg" :style="{backgroundImage: 'url(' + imgUrl + ')'}">
        <div class="top-banner-text">{{ imgTitle }}</div>
      </div>
    </div>
    <div class="xx-box-title" v-if="titleIndex">
      <div class="div">
        <div class="title">
          <div>{{ content[titleIndex].title }}</div>
        </div>
        <div class="line"><div></div></div>
        <div class="box-info">
          <div>{{ content[titleIndex].text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const bannerImgOne = require('../../static/images/img19.jpg')
const bannerImgTwo = require('../../static/images/img20.jpg')
const bannerImgThree = require('../../static/images/img18.jpg')
const bannerImgFour = require('../../static/images/img21.jpg')
const bannerImgFive = require('../../static/images/img12.jpg')
export default {
  props: ['titleIndex', 'imgUrl', 'imgTitle'],
  name: 'news',
  data() {
    return {
      imgList: [
        {
          url: bannerImgOne,
          text: ''
        },
        {
          url: bannerImgTwo,
          text: '有时候我们感受不到它的存在'
        },
        {
          url: bannerImgThree,
          text: '有时候灯光才是空间的主角'
        },
        {
          url: bannerImgFour,
          text: '自然与魔术的奇妙碰撞'
        },
        {
          url: bannerImgFive,
          text: '自然与魔术的奇妙碰撞'
        }
      ],
      content: [
        {
          title: '意大利灯饰品牌光与影合二为一',
          text: '灯具想来也是很多人的心头爱，它把金属材质运用到了淋漓尽致，每一件都堪称艺术品。当柔和的灯光和晶莹的金属交融在一起，奢华感扑面而来，恍若隔世。'
        },
        {
          title: '空间的解构和人文关怀是我们的追求',
          text: '我们不断对装饰设计行业进行探索与尝试；用适合的创意、简单的想法、解决问题。我们有一种感受，它会告诉你空间应该是什么样子，不是设计的有多好，而是这种感受本身就是美好的、感动的。以"传递感受为目的"并不直观，却比任何语言都更生动和准确。'
        },
        {
          title: '意大利灯饰品牌光与影合二为一',
          text: '灯具想来也是很多人的心头爱，它把金属材质运用到了淋漓尽致，每一件都堪称艺术品。当柔和的灯光和晶莹的金属交融在一起，奢华感扑面而来，恍若隔世。'
        },
        {
          title: '从专业的角度解读行业资讯，设计就在我们身边',
          text: '全世界许多国家都早已在智慧装饰上进行探寻，依靠优秀的互联网云计算技术、人工智能技术等技术性，智慧装饰已经变得越来越智能化，变成你我生活的一部分，在人们的生活办公中越来不可被取代。'
        },
        {
          title: '物联网技术照亮生活，道路灯饰正变得越来越智能化',
          text: '全世界许多国家都早已在智慧路灯上进行探寻，依靠优秀的互联网云计算技术、人工智能技术等技术性，路灯已经变得越来越智能化，变成一个智能的移动智能终端，在人们的生活起居中饰演愈来愈关键的人物角色。'
        }
      ]
    }
  }
}
</script>

<style></style>
